import ReactGA from "react-ga4";
import moment from "moment";

const TimeDifferenceGAEvent = (chartsData, page) => {
  const now = moment(moment.now());
  chartsData.map((item) => {
    const diff = 330 - moment.utc(item.lastUpdatedTimeStamp).diff(now, "minutes");
    ReactGA.event({
      category: "Time Difference In now - lastUpdatedAt",
      label: `${item.metric_id}`,
      action: page,
      value: diff,
    });
  });
};

export default TimeDifferenceGAEvent;
